import plantUml from "refractor/plant-uml";
export default plantUml;